import React from 'react'
import { Outlet } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  { path: '/pricing/management', label: 'Pricing Management' },
  { path: '/pricing/calendar', label: 'Pricing Calendar' },
  { path: '/pricing/rules', label: 'Pricing Rules' },
  { path: '/pricing/audit-log', label: 'Audit Log' }
]

function PricingPage() {
  return (
    <div className="page">
      <div className="pageHead">
        <h1>Pricing</h1>
        <p>Manage pricing rules, suggestions, and audit trail</p>
      </div>

      <PageTabs tabs={tabs} match="exact" />

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default PricingPage
